import { render, staticRenderFns } from "./ispServicelist.vue?vue&type=template&id=45b52a27&scoped=true&"
import script from "./ispServicelist.vue?vue&type=script&lang=js&"
export * from "./ispServicelist.vue?vue&type=script&lang=js&"
import style0 from "./ispServicelist.vue?vue&type=style&index=0&id=45b52a27&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b52a27",
  null
  
)

export default component.exports